
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/hotel/propertyDetailPage.lazy",
      function () {
        return require("private-next-pages/search/hotel/propertyDetailPage.lazy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/hotel/propertyDetailPage.lazy"])
      });
    }
  